import React from "react";
import { motion } from "framer-motion";
import bg from "../../assets/images/top-mountain-view.jpg";

const ORANGE = "#F27D2F";
const NAVY = "#2B3150";
const DOT_R = 8;

const stops = [
  { id: "lukla", label: "Lukla", x: 540, y: 1360 },
  { id: "phakding", label: "Phakding (2800m)", x: 560, y: 1250 },
  { id: "namche", label: "Namche Bazzar (3440m)", x: 330, y: 1020 },
  { id: "everestView", label: "Everest View Hotel (3880m)", x: 240, y: 920, left: true },
  { id: "tengboche", label: "Tengboche (3867m)", x: 420, y: 880 },
  { id: "dibuche", label: "Dibuche (3870m)", x: 480, y: 800 },
  { id: "pangboche", label: "Pangboche (3985m)", x: 520, y: 720 },
  { id: "dingboche", label: "Dingboche (4410m)", x: 570, y: 630 },
  { id: "pheriche", label: "Pheriche (4371m)", x: 520, y: 560 },
  { id: "dughla", label: "Dughla (4620m)", x: 570, y: 470 },
  { id: "lobuche", label: "Lobuche (4940m)", x: 600, y: 380, icon: "peak" },

  // ⭐ Corrected coordinates
  { id: "gorakshep", label: "Gorak Shep (5170m)", x: 640, y: 300 },

  // Forward main route
  { id: "ebc", label: "Everest Base Camp (5364m)", x: 760, y: 210, icon: "tent" },

  // ⭐ SIDE ROUTE (Branch)
  { id: "kalapatthar", label: "Kala Patthar (5545m)", x: 580, y: 200, icon: "peak" },
];

export default function RouteMap() {
  const PATH_LENGTH = 2600;

  const pathD = `
    M ${stops[0].x} ${stops[0].y}
    C ${stops[0].x + 10} ${stops[0].y - 110}, ${stops[1].x - 20} ${stops[1].y + 50}, ${stops[1].x} ${stops[1].y}
    C ${stops[1].x + 30} ${stops[1].y - 120}, ${stops[2].x - 40} ${stops[2].y + 30}, ${stops[2].x} ${stops[2].y}
    C ${stops[2].x + 40} ${stops[2].y - 140}, ${stops[3].x - 140} ${stops[3].y + 20}, ${stops[3].x} ${stops[3].y}
    C ${stops[3].x + 120} ${stops[3].y - 60}, ${stops[4].x - 30} ${stops[4].y + 0}, ${stops[4].x} ${stops[4].y}
    C ${stops[4].x + 30} ${stops[4].y - 70}, ${stops[5].x - 30} ${stops[5].y + 20}, ${stops[5].x} ${stops[5].y}
    C ${stops[5].x + 20} ${stops[5].y - 80}, ${stops[6].x - 30} ${stops[6].y + 30}, ${stops[6].x} ${stops[6].y}
    C ${stops[6].x + 40} ${stops[6].y - 70}, ${stops[7].x - 20} ${stops[7].y + 30}, ${stops[7].x} ${stops[7].y}
    C ${stops[7].x + 10} ${stops[7].y - 80}, ${stops[8].x - 20} ${stops[8].y + 20}, ${stops[8].x} ${stops[8].y}
    C ${stops[8].x + 60} ${stops[8].y - 120}, ${stops[9].x - 20} ${stops[9].y + 20}, ${stops[9].x} ${stops[9].y}
    C ${stops[9].x + 40} ${stops[9].y - 120}, ${stops[10].x - 20} ${stops[10].y + 40}, ${stops[10].x} ${stops[10].y}
    C ${stops[10].x + 30} ${stops[10].y - 80}, ${stops[11].x - 20} ${stops[11].y + 20}, ${stops[11].x} ${stops[11].y}
    C ${stops[11].x + 40} ${stops[11].y - 80}, ${stops[12].x - 30} ${stops[12].y + 20}, ${stops[12].x} ${stops[12].y}
  `;

  return (
    <div style={styles.page}>
      <div style={styles.wrapper}>
        <svg viewBox="0 100 900 1400" style={styles.svg}>

          <text x={30} y={420} style={{ fontSize: 48, fontWeight: 800, fill: NAVY }}>
            NEPAL
          </text>

          {/* Plane */}
          <g>
            <path
              d="M120 1360 C 250 1220, 420 1220, 540 1360"
              fill="none"
              stroke="#333"
              strokeWidth="2"
              strokeDasharray="6 4"
            />
            <g transform="translate(500,1330) rotate(18)" fill="#333">
              <path d="M0 0 L18 6 L0 12 L4 6 Z" />
              <rect x="-2" y="5" width="22" height="2" />
            </g>
            <circle cx="100" cy="1366" r="10" fill="#222" />
            <text x="60" y="1378" style={{ fontSize: 14, fill: "#111" }}>
              Kathmandu
            </text>
          </g>

          {/* Animated Main Route */}
          <motion.path
            d={pathD}
            fill="none"
            stroke="#2B2B2B"
            strokeWidth={4}
            strokeDasharray={PATH_LENGTH}
            strokeDashoffset={PATH_LENGTH}
            initial={{ strokeDashoffset: PATH_LENGTH }}
            animate={{ strokeDashoffset: 0 }}
            transition={{ duration: 6.5, ease: "easeInOut" }}
          />

          {/* ⭐ SEPARATE BRANCH: Gorak Shep → Kala Patthar */}
          <path
            d="M 640 300 C 610 260, 590 230, 580 200"
            stroke="#2B2B2B"
            strokeWidth="4"
            strokeDasharray="8 8"
            fill="none"
          />

          {/* Stops */}
          {stops.map((s, i) => {
            const dotDelay = 0.7 + i * 0.38;
            const labelDelay = dotDelay + 0.2;
            const offset = s.left ? -190 : 20;

            return (
              <g key={s.id}>
                <motion.circle
                  cx={s.x}
                  cy={s.y}
                  r={DOT_R}
                  fill={ORANGE}
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: dotDelay }}
                />

                <motion.circle
                  cx={s.x}
                  cy={s.y}
                  r={3}
                  fill="#222"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: dotDelay + 0.1 }}
                />

                <motion.text
                  x={s.x + offset}
                  y={
                    s.id === "gorakshep"
                      ? s.y - 20
                      : s.id === "ebc"
                      ? s.y + 30
                      : s.id === "kalapatthar"
                      ? s.y - 10
                      : s.y - 12
                  }
                  style={{ fontSize: 25, fill: NAVY, fontWeight: 700 }}
                  initial={{ opacity: 0, x: s.left ? -10 : 10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: labelDelay }}
                >
                  {s.label}
                </motion.text>
              </g>
            );
          })}

        </svg>
      </div>
    </div>
  );
}

const styles = {
  page: {
    width: "100%",
    minHeight: "100vh",
    background: "#00000060",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  wrapper: {
    width: 650,
    height: 570,
    overflow: "hidden",
    borderRadius: 6,
    boxShadow: "0 6px 30px rgba(0,0,0,0.25)",
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  svg: {
    width: "100%",
    height: "100%",
  },
};
